<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ata"></a></p>
<div class="fmhT"><b>About the Author</b></div>
<div class="fmtx1">Kim Heldman is the Chief Information Officer for the Colorado Department of Natural Resources. She has more than 14 years of project management experience in the information technology field. She has managed small, medium, and large projects over the course of her career and shares her breadth of experience and knowledge in her books through examples, stories, and tips.</div>
<div class="fmtx">Kim Heldman is the author of several other project management books, including <i>PMP Final Exam Review, Project Management JumpStart,</i> and the top-selling <i>PMP: Project Management Professional Study Guide</i>, all from Sybex<i>.</i>  You can learn more about Kim at her website: <a href="http://www.KimHeldman.com" target="_blank">www.KimHeldman.com</a>.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// held_9781118000229_oeb_ata_r1.vue?46f2c9ff